module.exports = __webpack_public_path__ + "img/logo-viviri.png";